<template>
  <section class="modal-standard">
    <h1 class="popup-title a11y-hidden">팝업</h1>
    <div class="popup-button-close">
      <button type="button" @click.prevent="$emit('on-cancel')">
        <img
          :src="require('@/assets/images/common/btn-popup-close.svg')"
          alt="팝업 닫기"
        />
      </button>
    </div>

    <component
      :is="component"
      v-if="component"
      :key="`modal__standard__${component.name}`"
      :payloads="payloads"
      @on-confirm="onConfirm"
      @on-cancel="emit('on-cancel')"
    />
  </section>
</template>
<script setup>
  import { defineProps, defineEmits, computed } from 'vue'
  import { EventBus } from '@/common/utils/event-bus'
  import { MODAL_STANDARD_CONFIRM } from '@/common/resources/const'
  import ModalStandardContent from '@/pages/popup/fragments/ModalStandardContent.vue'

  const props = defineProps({
    payloads: {
      type: Object,
      default: () => ({}),
    },
  })
  const emit = defineEmits(['on-confirm', 'on-cancel'])
  const component = computed(
    () => props.payloads?.component ?? ModalStandardContent,
  )
  const onConfirm = () => {
    EventBus.$emit(MODAL_STANDARD_CONFIRM, {
      isSuccess: true,
      payloads: props.payloads,
    })
  }
</script>
<style scoped lang="scss">
  .modal-standard {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 560px;
    padding: 40px;
    background-color: #252525;
    border-radius: 8px;
  }
</style>
